import { CommonModule, DatePipe } from '@angular/common';
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpClientModule,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastrModule } from 'ngx-toastr';
import { MustMatchDirective } from './directive/match.validator';
import { GlobalErrorHandler } from './handlers';
import { JwtInterceptor, ServerErrorInterceptor } from './interceptors';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { CustomDatePipePipe } from './pipe/custom-date-pipe.pipe';
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { OtpTimerComponent } from './shared/components/otp-timer/otp-timer.component';
import { ScratchCardComponent } from './shared/components/scratch-card-view/scratch-card-view.component';
import { VoucherDialogComponent } from './shared/components/voucher-dialog/voucher-dialog.component';
import { NgxConfettiExplosionComponent } from 'ngx-confetti-explosion';
import { VoucherDetailsDialogComponent } from './shared/components/voucher-dialog/voucher-details-dialog/voucher-details-dialog.component';
import { VoucherViewComponent } from './shared/components/voucher-view/voucher-view.component';
import { VoucherCardsComponent } from './shared/components/voucher-cards/voucher-cards.component';
import { CreditRewardDialogComponent } from './shared/components/credit-reward-dialog/credit-reward-dialog.component';
import { CreditRewardViewComponent } from './shared/components/credit-reward-dialog/credit-reward-view/credit-reward-view.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxStarsModule } from 'ngx-stars';
import { RatingDialogComponent } from './shared/components/rating-dialog/rating-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FilmRatingListDialogComponent } from './shared/components/film-rating-list-dialog/film-rating-list-dialog.component';
import { LanguagePreferenceModalComponent } from './shared/components/language-preference-modal/language-preference-modal.component';
import { TranslatePipe } from './pipe/translate.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    MustMatchDirective,
    CustomDatePipePipe,
    ConfirmationDialogComponent,
    SafeUrlPipe,
    OtpTimerComponent,
    ScratchCardComponent,
    VoucherDialogComponent,
    VoucherDetailsDialogComponent,
    VoucherViewComponent,
    VoucherCardsComponent,
    CreditRewardDialogComponent,
    CreditRewardViewComponent,
    RatingDialogComponent,
    FilmRatingListDialogComponent,
    LanguagePreferenceModalComponent,
    TranslatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    NgSelectModule,
    NgxConfettiExplosionComponent,
    CarouselModule,
    NgxStarsModule,
    HttpClientModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    DatePipe,
  ],
  exports: [
    FormsModule,
    MustMatchDirective,
    TranslateModule,
    ModalModule,
    NgSelectModule,
    CustomDatePipePipe,
    TooltipModule,
    ConfirmationDialogComponent,
    SafeUrlPipe,
    OtpTimerComponent,
    ScratchCardComponent,
    VoucherDialogComponent,
    VoucherDetailsDialogComponent,
    VoucherViewComponent,
    VoucherCardsComponent,
    CreditRewardDialogComponent,
    CreditRewardViewComponent,
    RatingDialogComponent,
    FilmRatingListDialogComponent,
    LanguagePreferenceModalComponent,
    TranslatePipe,
    MatIconModule,
    MatTooltipModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {}

export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
  const url = '/assets/i18n/';
  return new TranslateHttpLoader(http, url, '.json');
}
